<template>
  <div class="chart-container">
    <h3 v-if="chartData.datasets[0].data.length === 0">No matching results</h3>
    <PolarChart
      :chart-data="chartData"
      :options="options"
      style="width: 100%; height: 100%"
    />
  </div>
</template>

<script>
import PolarChart from "@/components/PolarChart.vue";
import { default as pie_defaults } from "@/views/ANJt3s2fB3aYft5ni6yDeQ.vue";

export default {
  components: {
    PolarChart,
  },
  data() {
    return {
      chartData: {
        labels: [],
        datasets: [{ data: [] }],
      },
      options: {
        responseive: true,
        maintainAspectRatio: false,
        resizeDelay: 0,
        legend: {
          labels: {
            fontFamily: "Noto Sans",
          },
          display: false,
        },
      },
      forms: {
        activeMetric: null,
        activeHost: null,
        activeOperation: null,
        activeGroup: null,
        reduceOperation: null,
        showLegend: null,
        chartColor: null,
      },
      context: {
        dashboard: null,
      },
      query: null,
      metricsList: [],
      colorTheme: "light",
      timer: null,
    };
  },
  created: pie_defaults.created,
  mounted: pie_defaults.mounted,
  methods: pie_defaults.methods,
};
</script>
<style>
.chart-container {
  overflow: hidden;
  position: relative;
  padding: 0px;
  height: 94vh;
  width: 97vw;
}
</style>